module.exports = __webpack_public_path__ + "media/images/flags/1x1/atf-177f6e066b530cd86656ce4147eaa521.svg";